export default {
  "dashboard.title": "Bienvenido de nuevo",
  "dashboard.noAccount.title": "Agregar Tu Cuenta PAMM",
  "dashboard.noAccount.description": "Necesitas una cuenta de inversión PAMM activa para activar tu usuario y disfrutar de los beneficios de TheClub",
  "dashboard.noAccount.skipButton": "Omitir",
  "dashboard.noAccount.addAccountButton": "Agregar Cuenta PAMM",
  "dashboard.subtitle": "Construye tu futuro con The Club",
  "dashboard.totalEarnings.lifetime": "Ganancias Totales",
  "dashboard.totalEarnings.lastMonth": "Ganancias Totales",
  "dashboard.totalEarnings.breakdown.accounts": "Ganancias de la Cuenta Trading",
  "dashboard.totalEarnings.breakdown.commissions": "Comisiones de tu Comunidad",
  "dashboard.community.combined.title": "Resumen de Mi Comunidad",
  "dashboard.userInfo.combined.title": "Perfil",
  "dashboard.charts.totalEarningsOverTime": "Ganancias Totales en el Tiempo",
  "dashboard.userProfile.title": "Resumen del Perfil",
  "dashboard.userProfile.username": "Nombre de usuario",
  "dashboard.userProfile.memberSince": "Miembro desde",
  "dashboard.userProfile.rank": "Rango",
  "dashboard.userProfile.status": "Estado",
  "dashboard.userStats.title": "Estadísticas Rápidas",
  "dashboard.userStats.referralLink": "Enlace de Referido",
  "dashboard.userStats.commissionModel": "Modelo de Comisión",
  "dashboard.userStats.communityValue": "Valor de la Comunidad",
  "dashboard.userStats.linkCopied": "¡Enlace copiado!",
  "dashboard.userStats.linkCopiedDesc": "Enlace de referido copiado al portapapeles",
  "dashboard.userStats.rank": "Rango",
  "dashboard.profits.lifetime": "Ganancias Acumuladas de la Cuenta de Trading",
  "dashboard.profits.lastMonth": "Ganancias del Último Mes de la Cuenta de Trading",
  "dashboard.profits.accountsProfits.title": "Ganancias de la Cuenta de Trading",
  "dashboard.profits.commissions.title": "Comisiones de tu Comunidad",
  "dashboard.commissions.lifetime": "Comisiones Totales",
  "dashboard.commissions.lastMonth": "Comisiones",
  "dashboard.commissions.lastMonthWithMonth": "Comisiones de",
  "dashboard.commissions.currentBalance": "Saldo Actual",
  "dashboard.commissions.totalPaid": "Total Pagado",
  "dashboard.community.totalReferrals": "Referidos Totales",
  "dashboard.community.totalReferralsDesc": "Todos los Niveles Combinados",
  "dashboard.community.communityValue": "Valor de tu Comunidad",
 "dashboard.community.communityValueDesc": "Valor Total de su Comunidad",
  "dashboard.mycommunity.title": "Mi Comunidad",
  "dashboard.charts.profitsOverTime": "Ganancias de la Cuenta de Trading en el Tiempo",
  "dashboard.charts.commissionsOverTime": "Comisiones en el Tiempo",
  "dashboard.charts.accountProfit": "Ganancia de Cuenta de Trading",
  "dashboard.charts.commissionAmount": "Monto de Comisión",
  "dashboard.charts.totalEarnings": "Ganancias Totales",
  "dashboard.months.jan": "Ene",
  "dashboard.months.feb": "Feb",
  "dashboard.months.mar": "Mar",
  "dashboard.months.apr": "Abr",
  "dashboard.months.may": "May",
  "dashboard.months.jun": "Jun",
  "dashboard.months.jul": "Jul",
  "dashboard.months.aug": "Ago",
  "dashboard.months.sep": "Sep",
  "dashboard.months.oct": "Oct",
  "dashboard.months.nov": "Nov",
  "dashboard.months.dec": "Dic",
  "dashboard.monthsFull.jan": "Enero",
  "dashboard.monthsFull.feb": "Febrero",
  "dashboard.monthsFull.mar": "Marzo",
  "dashboard.monthsFull.apr": "Abril",
  "dashboard.monthsFull.may": "Mayo",
  "dashboard.monthsFull.jun": "Junio",
  "dashboard.monthsFull.jul": "Julio",
  "dashboard.monthsFull.aug": "Agosto",
  "dashboard.monthsFull.sep": "Septiembre",
  "dashboard.monthsFull.oct": "Octubre",
  "dashboard.monthsFull.nov": "Noviembre",
  "dashboard.monthsFull.dec": "Diciembre",
  "dashboard.loading": "Cargando datos del panel...",
  "dashboard.error": "Error al cargar los datos del panel",
  "dashboard.status.active": "Activo",
  "dashboard.status.inactive": "Inactivo",
  "dashboard.profits.lastMonthWithMonth": "Ganancias de la Cuenta de Trading",
};
